<template>
  <div>
    <div v-if="!button.edit" class="mt-2">
      <w-button class="btn-light float-left" :icon="button.icon" :text="button.name" :style="{ color: button.color }" />

      <w-button class="btn-light float-right" icon="fal fa-pencil" text="Edytuj" @click="edit" />

      <w-button class="btn-light float-right mr-2" icon="fal fa-trash" text="Usuń" @click="remove" />
    </div>

    <div v-else class="row">
      <w-input class="col-md-12 form-group" :model="$schema.name" />

      <w-input class="col-md-4 form-group" :model="$schema.color" />

      <w-input class="col-md-4 form-group" :model="$schema.icon" />

      <w-input class="col-md-4 form-group" :model="$schema.order" />

      <w-select class="col-md-6 form-group" :model="$schema.action" :values="actions" />

      <w-input class="col-md-6 form-group" :model="$schema.routeName" />

      <div class="col-md-12 form-group">
        <label>{{ $schema.roleIds.$title }}</label>

        <button-form-roles :model="$schema.roleIds" />

        <w-error :model="$schema.roleIds" />
      </div>

      <w-monaco v-if="$schema.action.$model" language="json" class="col-md-12" :model="$schema.actionData" />

      <div class="col-md-12 mt-4">
        <w-button class="btn-warning float-left" icon="fal fa-times" text="Anuluj" @click="cancel" />

        <w-button class="btn-primary float-right" icon="fal fa-check" text="Zapisz" @click="save" />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonFormRoles from './ButtonFormRoles';
import { ActionList } from '@/enums/action.enum';
import { Errors } from '@/enums/errors.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/button.schema';

// @vuese
// Formularz przycisku
export default {
  components: { ButtonFormRoles },
  mixins: [formMixin, notificationsMixin],
  schema,
  props: {
    // Przycisk do edycji
    button: { type: Object, required: true }
  },
  data() {
    return { model: { action: null, actionData: null }, actions: [{ value: null, text: 'Bez akcji' }, ...ActionList] };
  },
  computed: {
    buttonData() {
      return {
        ...this.button,
        actionData: this.button.actionData ? JSON.stringify(this.button.actionData, undefined, 2) : undefined
      };
    }
  },
  watch: {
    'button.edit'() {
      this.$schema.$setData(this.buttonData);
    }
  },
  mounted() {
    this.$schema.$setData(this.buttonData);
  },
  methods: {
    // @vuese
    // Zapis przycisku
    save() {
      if (this.$schema.$validateAll().length) {
        return this.notifyError(Errors.FORM_INCORRECTLY_COMPLETED);
      }
      this.$emit('save', this.$schema.$getData());
    },

    // @vuese
    // Anuluje edycję przycisku
    cancel() {
      this.$emit('cancel');
    },

    // @vuese
    // Otwiera edycję przycisku
    edit() {
      this.$emit('edit');
    },

    // @vuese
    // Usuwa przycisk
    remove() {
      this.$emit('remove');
    }
  }
};
</script>
